<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import './assets/css/default.css'
  export default {
    name: "App",
  }
</script>

<style>

</style>
